module.exports = __webpack_public_path__ + "img/selected.e212c87a.svg";